// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { of, tap } from 'rxjs';
import { delay } from 'rxjs/operators';
import { DocumentsService } from '@services/documents.service';

@Component({
    selector: 'app-pddj-done',
    templateUrl: './pddj-done.component.html',
    styleUrls: ['./pddj-done.component.scss'],
})
export class PddjDoneComponent implements OnInit {
    constructor(
        private readonly documentService: DocumentsService,
        private readonly router: Router
    ) {}

    ngOnInit(): void {
        this.documentService.pddjDocumentQueue = [];
        this.documentService.pddjDocument = null;
        this.documentService.pddjDocumentQueueSessionCount = 0;
        of(null)
            .pipe(
                delay(1500),
                tap(() => (<any>window).chrome?.webview?.postMessage({ done: true })),
                delay(500),
                tap(() => this.router.navigate(['/pddj', 'status']))
            )
            .subscribe();
    }
}
